module.exports = __webpack_public_path__ + "img/defaultAvatar.57e332d9.svg";